import React from 'react';
import { Building2 } from 'lucide-react';

// Logos oficiais (SVG) em /public/bancos — fonte: pacote logos-bancos-br (MIT),
// gerado a partir das listas do Banco Central e do Open Finance Brasil.
const BANK_FILES = {
  'Nubank': 'nubank',
  'Itaú': 'itau',
  'Bradesco': 'bradesco',
  'Santander': 'santander',
  'Banco do Brasil': 'banco-do-brasil',
  'Caixa': 'caixa',
  'Inter': 'inter',
  'C6 Bank': 'c6-bank',
  'Cora': 'cora',
  'EFI Bank': 'efi-bank',
  'Sicoob': 'sicoob',
  'Sicredi': 'sicredi',
  'BTG Pactual': 'btg-pactual',
  'XP': 'xp',
  'Mercado Pago': 'mercado-pago',
  'PicPay': 'picpay',
};

const normalize = (s) => (s || '').toString().trim().toLowerCase();
const BY_NORMALIZED = Object.fromEntries(Object.entries(BANK_FILES).map(([k, v]) => [normalize(k), v]));

export const hasBankLogo = (nome) => Boolean(BY_NORMALIZED[normalize(nome)]);

// Mostra o logo do banco pelo nome da conta; sem logo conhecido, cai no
// ícone genérico colorido (contas com nome personalizado, "Outro" etc.).
export default function BankIcon({ nome, cor = '#64748b', size = 36, className = '' }) {
  const file = BY_NORMALIZED[normalize(nome)];
  const box = { width: size, height: size };

  if (file) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-xl border border-slate-200/80 overflow-hidden flex-shrink-0 ${className}`}
        style={{ ...box, background: '#fff' }}
      >
        <img src={`/bancos/${file}.svg`} alt={nome} className="w-full h-full object-contain p-[12%]" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-xl flex-shrink-0 ${className}`}
      style={{ ...box, background: `${cor}22`, color: cor }}
    >
      <Building2 size={Math.round(size * 0.5)} />
    </span>
  );
}
